import { ReactElement } from 'react';
import { startOfYear, formatISO } from 'date-fns';
import { Breadcrumb, DownloadButton, EnterpriseField, Heading, Page, PeriodPickerField, withHasPerm } from 'components';
import { CheckField, DateRangePickerField, Form } from '@ff-it/form';
import { FormSpy } from 'react-final-form';
import permissions from '../permissions';
import { any, useHasPerm } from 'core/permissions';
import { usePeriod } from 'modules/reporting/usePeriod';
import { CompanyField } from 'modules/core/company/components';
import { StateFilterField, TypeFilterField } from 'modules/reporting/Filter';

const onSubmit = (): void => undefined;

function RenderReport({ global, managed }: { global: boolean; managed?: boolean }): ReactElement {
  const initialValues = {
    date_from: formatISO(startOfYear(new Date()), { representation: 'date' }),
    date_to: null,
    agency: [],
    client: [],
    payer: [],
    provider: [],
  };

  const { date_from: minDate, date_to: maxDate } = usePeriod();
  return (
    <Page>
      <Breadcrumb to={null}>Raw report</Breadcrumb>
      <Heading title="Raw report"></Heading>
      <div className="container px-0 ml-0">
        <Form onSubmit={onSubmit} initialValues={initialValues}>
          <div className="form-row">
            {global && (
              <EnterpriseField
                name="agency"
                isMulti
                className="col"
                defaultOptions
                placeholder="All agencies"
                label="Agencies"
              />
            )}
            <div className="col-3 mb-3">
              <DateRangePickerField
                label="Period"
                fromName="date_from"
                toName="date_to"
                minDate={minDate}
                maxDate={maxDate}
                className="mb-1"
              />
              <PeriodPickerField fromName="date_from" toName="date_to" minDate={minDate} maxDate={maxDate} />
            </div>
            <StateFilterField label="State" className="col" />
            <TypeFilterField global={global} className="col" label="Type" />
          </div>
          <div className="form-row">
            <CompanyField name="client" label="Client" className="col" isMulti includeBranches={true} />
            <CompanyField name="payer" label="Payer" className="col" isMulti includeBranches={true} />
            <CompanyField name="provider" label="Provider" className="col" isMulti includeBranches={true} />
          </div>
          <div className="form-group mb-1 mb-4">
            <CheckField name="income_no" fieldLabel="Income Invoice No" variant="switch" />
            <CheckField name="expense_no" fieldLabel="Expense Invoice No" variant="switch" />
            <CheckField name="product" fieldLabel="Products" variant="switch" />
          </div>

          <FormSpy subscription={{ values: true }}>
            {({ values }) => (
              <DownloadButton
                method="POST"
                body={values}
                url={`reporting/raw/${global ? 'global' : managed ? 'local_managed' : 'local'}/`}
                icon="file-excel"
                title="Export"
              >
                Export
              </DownloadButton>
            )}
          </FormSpy>
        </Form>
      </div>
    </Page>
  );
}

export const Local = withHasPerm(
  () => {
    const managed = !useHasPerm(permissions.local);
    return <RenderReport global={false} managed={managed} />;
  },
  any(permissions.local, permissions.local_managed),
);
export const Global = withHasPerm(() => <RenderReport global={true} />, permissions.global);
